/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProductsJsmOrganizationDetails from '@jira/admin-pages__products-jsm-organization-details/src/OrganizationDetailsPage.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProductsJsmOrganizationDetails: LazyComponent<() => React.JSX.Element> =
	lazyForPaint<typeof ProductsJsmOrganizationDetails>(() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-products-jsm-organization-details", jiraSpaEntry: "async-products-jsm-organization-details" */ '@jira/admin-pages__products-jsm-organization-details/src/OrganizationDetailsPage.tsx'
			),
		),
	);

const AsyncProductsJsmOrganizationDetails = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProductsJsmOrganizationDetails}
		pageId="products-jsm-organization-details"
		shouldShowSpinner
	/>
);

export default AsyncProductsJsmOrganizationDetails;
